/* ============================================
   DASHBOARD LAYOUT - Main Admin Shell
   Protected Container with Sidebar
   ============================================ */

import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

export default function Dashboard() {
  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <Outlet />
      </div>
      <style>{`
        .dashboard-layout {
          display: flex;
          min-height: 100vh;
        }
        .dashboard-main {
          flex: 1;
          margin-left: 240px;
          background: #f5f5f5;
          min-height: 100vh;
        }
        @media (max-width: 768px) {
          .dashboard-main {
            margin-left: 200px;
          }
        }
      `}</style>
    </div>
  );
}
